import './book-dialog.scss'
import { useEffect, useCallback, useState, useMemo } from 'react'
import CommonModal from '@/components/CommonModal/CommonModal'
import { useStore } from '@/store'
import { useLocal } from '@/i18n/LocalContext'
import { toast } from '@/utils'
import appExpose from '@app/expose'
import { Handler } from 'mitt'
import { SellRecord } from '@app/store/sell'
import { getSellRecordList } from '@app/request'
import { time2str } from '@base/lang'

const { emitter } = appExpose

export default function BookDialog() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const bookDialogOpen = state.bookDialogModalOpen
  const playerId = state.login.userInfo.playerId
  const [list, setList] = useState<SellRecord[]>([])
  const getOwner = useCallback(
    (item: SellRecord) =>
      item.category === 1
        ? `<span>[S-${item.kid}]</span><a>${item.name}</a>`
        : $t('我'),
    []
  )
  const getBookTime = useCallback(
    (item: SellRecord) => time2str(item.date * 1000, 'date-time'),
    []
  )
  const getBookInfo = useCallback(
    (item: SellRecord) =>
      item.category === 1
        ? $t('来到我方集市进行售卖%{num1}圣诞树，获得%{num2}圣诞币')
            .replace('%{num1}', `<i>${String(item.tree)}</i>`)
            .replace('%{num2}', `<i>${String(item.coin)}</i>`)
        : $t('在%{name}集市进行售卖%{num1}圣诞树，获得%{num2}圣诞币')
            .replace(
              '%{name}',
              `<span>[S-${item.kid}]</span><a>${item.name}</a>`
            )
            .replace('%{num1}', `<i>${String(item.tree)}</i>`)
            .replace('%{num2}', `<i>${String(item.coin)}</i>`),
    []
  )
  const [onlySelf, setOnlySelf] = useState(false)
  const checkboxClassName = useMemo(() => {
    if (onlySelf) {
      return 'book-dialog-checkbox checked'
    }

    return 'book-dialog-checkbox'
  }, [onlySelf])
  const check = useCallback(() => {
    setOnlySelf((prev) => !prev)
  }, [])

  const viewList = useMemo(() => {
    if (!onlySelf) return list

    return list.filter((item) => item.category === 2)
  }, [list, onlySelf])

  useEffect(() => {
    const _handle: Handler<MittEvents['updateBookData']> = async () => {
      const data = await getSellRecordList(playerId)
      setList(data)
    }
    emitter.on('updateBookData', _handle)

    return () => {
      emitter.off('updateBookData', _handle)
    }
  }, [playerId])

  const onClose = useCallback(() => {
    dispatch({ type: 'setState', data: { bookDialogModalOpen: false } })
  }, [])

  return (
    <CommonModal
      open={bookDialogOpen}
      onClose={onClose}
      title={$t('售卖记录')}
      type="book-dialog"
    >
      {[
        <div key="1" className="book-dialog">
          <ul className="book-list">
            {viewList.map((item, n) => (
              <li key={n} className="book-item">
                <div className="book-owner-block">
                  <p
                    className="book-owner"
                    dangerouslySetInnerHTML={{ __html: getOwner(item) }}
                  ></p>
                  <span className="book-time">{getBookTime(item)}</span>
                </div>
                <div
                  className="book-cont"
                  dangerouslySetInnerHTML={{ __html: getBookInfo(item) }}
                ></div>
              </li>
            ))}
          </ul>
        </div>,
        <div key="2" className="book-dialog-footer" onClick={check}>
          <a className={checkboxClassName}></a>
          <span>{$t('只显示自己售卖记录')}</span>
        </div>,
      ]}
    </CommonModal>
  )
}
